import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["modal"];

    connect() {}

    launch(event) {
        let modalController = this.application.getControllerForElementAndIdentifier(
            this.modalTarget,
            "unit-size-info"
        );
        modalController.setContent(event.currentTarget.dataset);
        modalController.open();
    }
}